import get from 'lodash/get'
import has from 'lodash/has'
import isPlainObject from 'lodash/isPlainObject'
import sortBy from 'lodash/sortBy'
import {createSelector} from 'reselect'

import {RecommendedItemsOrder} from './enumTS'
import {ATL_ORIGIN_CTL, TRANSACTION_TYPE_RENT} from '../const'

// Standard
export const product = (state) => get(state, 'product')
export const productsBySlug = (state) => get(state, 'product.productsBySlug')
export const recommendedItems = (state) => get(state, 'product.recommendedItems.items')

// -- Boolean

export const recommendedItemsIsPending = (state) =>
  !!get(state, 'product.recommendedItems.isPending')

// -- Helpers
const getItemBySlug = (items, slug) => (has(items, slug) ? items[slug] : null)

// -- Products
export const getProduct = (state, slug) => getItemBySlug(productsBySlug(state), slug)
export const productExists = (state, slug) => isPlainObject(getProduct(state, slug))
const productStatus = (state, slug) => get(getProduct(state, slug), 'status')
export const productIsOk = (state, slug) =>
  productExists(state, slug) && productStatus(state, slug) === 'OK'
export const getProductName = (state, slug) => get(getProduct(state, slug), 'name')

export const getProductBuyPrice = (state, slug) => get(getProduct(state, slug), 'buyPrice')
export const getProductBuyPriceNumber = (state, slug) =>
  parseInt(getProductBuyPrice(state, slug), 10)
export const getProductRentPrice = (state, slug) => get(getProduct(state, slug), 'rentPrice')
export const getProductRentPriceNumber = (state, slug) =>
  parseInt(getProductRentPrice(state, slug), 10)

export const getProductDisplayCategorySlug = (state, slug) =>
  get(getProduct(state, slug), 'setSpecs.defaultDisplayCategorySlug')
export const getProductUrlSlug = (state, slug) => get(getProduct(state, slug), 'urlSlug')
export const getProductUri = (state, slug) =>
  `/collections/product/${getProductUrlSlug(state, slug)}`
export const getProductImages = (state, slug) => get(getProduct(state, slug), 'setImages')
export const getProductOutfitItems = (state, slug) => get(getProduct(state, slug), 'setChildren')
export const getProductDescription = (state, slug) => get(getProduct(state, slug), 'description')

// Computed

/**
 * Sorts items by category according to order provided by enum
 * @return {Array} Returns a new sorted array of recommended items
 */
export const sortedRecommendedItems = createSelector(recommendedItems, (items) =>
  sortBy(
    items.map((item) => item.recommendedSet),
    (item) => RecommendedItemsOrder.indexOf(item.defaultDisplayCategorySlug),
  ),
)

/**
 * Returns an array of the recommended items
 * @param {Array} sortedRecommendedItems: all accessory items
 * @return {Array} Gathers applicable data for each recommended item
 */
export const addToLookRecommendedItemsArray = createSelector(sortedRecommendedItems, (items) =>
  items.map((item) => ({
    categorySlug: item.defaultDisplayCategorySlug,
    name: item.name,
    origin: ATL_ORIGIN_CTL,
    setType: 'recommendedItems',
    slug: item.slug,
    transactionType: TRANSACTION_TYPE_RENT,
  })),
)
